export default class CaptchaService {

  static getCaptchaData(ref){
    let dom = ref.current;

    if (dom){
      let text = dom.captchaInputRef.current.value;
      let cID = sessionStorage.getItem("cID");
      return {
        cId: cID,
        cText: text
      }
    } else {
      return {};
    }
  }

  static refreshCaptcha(ref){
    let dom = ref.current;

    if (dom){
      let refreshBtn = dom.refreshButtonRef.current;
      let text = dom.captchaInputRef.current;
      text.value = "";
      refreshBtn.click();
    }
  }

}